import { baseUrl } from "./type";
import http from "./http";

// 取得所有標籤
export function getTagDetail(token) {
    return new Promise((resolve, reject) => {
        http.get(baseUrl + `tags/getTagDetail`, {
            headers: {
                Authorization: "Bearer " + token,
            },
        })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
    });
};

// 移除標籤
export function removeTagRelations(token, tagId, entityType, entityId) {
    return new Promise((resolve, reject) => {
        let body = {
            tagId: tagId
        };

        if (entityType) {
            body.entityType = entityType;
        }
        if (entityId) {
            body.entityId = entityId;
        }

        http.delete(baseUrl + `tags/removeTagRelations`, {
                headers: {
                    Authorization: "Bearer " + token,
                },
                data: body
            })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
    });
}

// 編輯標籤 (字串變字串)
export function editTag(token, tagId, tagName, type) {
    return new Promise((resolve, reject) => {
        let body = {
            tagId: tagId,
            tagName: tagName,
        };

        if (type) {
            body.type = type;
        }

        http.patch(baseUrl + `tags/updateTagRelations`, body, {
                headers: {
                    Authorization: "Bearer " + token,
                }
            })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
    });
}

// 寫入標籤
export function addTag(token, tagName, entityType, entityId) {
    return new Promise((resolve, reject) => {
        http.post(baseUrl + `tags/addTag`, 
            {
                tagName: tagName,            // ex: #黑名單
                entityType: entityType,      // ex: branches   // branches, users, service, brand_products, brand_events，5 選 1
                entityId: entityId           // ex: 5
            }, 
            {
                headers: {
                    Authorization: "Bearer " + token,
                }
            })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
    });
};

// 更新標籤 (陣列變陣列)
export function updateTag(token, entityType, entityId, tagName) {
    return new Promise((resolve, reject) => {
        http.put(baseUrl + `tags/updateTagRelations`, 
            {
                type: entityType,
                entityId: entityId,       
                tagNames: tagName,          
            }, 
            {
                headers: {
                    Authorization: "Bearer " + token,
                }
            })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
    });
};


// 刪除特定 typeId 
export function deleteManyTag(token, entityType, entityId) {
    return new Promise((resolve, reject) => {
        http.delete(baseUrl + `tags/removeManyEntityTagRelation`, 
            {
                headers: {
                    Authorization: "Bearer " + token,
                },
                data: {
                    type: entityType,
                    entityId: entityId,               
                }, 
            })
            .then((response) => resolve(response))
            .catch((err) => reject(err));
    });
};